import Vue from "vue";
import SectorList from "./SectorList.vue";

export function load() {
  const selector = "SectorList-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(SectorList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
